import React from "react";
import { Select, Form } from "antd";
import "../../styles/customSelect.css";
import { InputLoading } from "./InputLoading";

const CustomSelect = ({
  label,
  placeholder,
  name,
  options,
  formItemProps,
  mode,
  defaultValue,
  required,
  onSearch,
  onChange,
  disabled,
  labelInValue,
  handleCreateNew,
  type,
  allowClear = true,
  customPlaceholderColor = false,
  loading,
}) => {
  const handleSearch = (input) => {
    if (onSearch) {
      onSearch(input);
    }
  };

  const handleChange = (value) => {
    if (onChange) {
      onChange(value);
    }
  };

  // Show skeleton loader when loading
  if (loading) {
    return (
      <div>
        {label && (
          <label className="inline-flex w-full text-sm text-black form-label flex pl-0.5 py-0.5">
            {label}
            {required && <span className="text-red-500">*</span>}
          </label>
        )}
        <InputLoading />
      </div>
    );
  }

  return (
    <Form.Item
      label={
        required ? (
          <span>
            {label}
            <span style={{ color: "red" }}>*</span>
          </span>
        ) : (
          label
        )
      }
      name={name}
      {...formItemProps}
      rules={[{ required: required, message: `${label} is required` }]}
      labelCol={{ span: 24 }}
      wrapperCol={{ span: 24 }}
      style={{ marginBottom: "0.75rem" }}
      required={false}
    >
      <Select
        disabled={disabled}
        labelInValue={labelInValue}
        allowClear={allowClear}
        showSearch
        mode={mode}
        placeholder={placeholder}
        optionFilterProp="label"
        filterOption={(input, option) => {
          const label = String(option?.label ?? "");
          return label.toLowerCase().includes(input.toLowerCase());
        }}
        // filterSort={(optionA, optionB) => {
        //   const labelA = String(optionA?.label ?? "");
        //   const labelB = String(optionB?.label ?? "");
        //   return labelA.toLowerCase().localeCompare(labelB.toLowerCase());
        // }}
        className="custom-select"
        style={{
          "--placeholder-color": customPlaceholderColor ? "#000000" : "#8c8c8c",
        }}
        autoClearSearchValue
        options={options}
        defaultValue={defaultValue?.value}
        onSearch={handleSearch}
        onChange={handleChange}
        dropdownRender={(menu) => (
          <>
            {menu}
            {handleCreateNew && (
              <div
                className="text-[#2271b8] font-medium cursor-pointer px-3 py-1 hover:bg-gray-100"
                onClick={() => handleCreateNew(type)}
              >
                {`Create New ${type}`}
              </div>
            )}
          </>
        )}
      />
    </Form.Item>
  );
};

export default CustomSelect;
